import React from 'react';

export type StudyTypeFormatterProps = {
  studyType: string;
  // studyInfoDrawer.tsx passes a number|undefined here (linkedStudies.length /
  // followOnStudy), only ever used in a truthy check below - pre-existing.
  isFollowOnStudy: boolean | number | undefined;
  isTextButton?: boolean;
  handleClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  isDisabled?: boolean;
};

const StudyTypeFormatter = ({
  studyType,
  isFollowOnStudy,
  isTextButton = false,
  handleClick = () => {},
  isDisabled = false,
}: StudyTypeFormatterProps) => {
  if (isTextButton) {
    return (
      <button disabled={isDisabled} onClick={handleClick} className="item-value-btn">
        <span>{studyType}</span>
      </button>
    );
  }
  return (
    <div className="flex items-center">
      <div>{studyType}</div>
      {isFollowOnStudy ? <div className="follow-on-study-label">FO</div> : null}
    </div>
  );
};

export default StudyTypeFormatter;
